import { getPageType } from 'utils/get-page-type';
import env from 'env/env';
import { MonetateApiRequestBody } from 'redux/modules/experiments/actions/types';

interface BuildRequestBodyParams {
  branchId?: string | null;
  customerId?: string;
  ipAddress?: string;
  marketingPreferencesAcknowledged?: boolean;
  monetateId?: string;
  path: string;
  preview?: string;
  requestId: string;
  slotDate?: string;
  slotType?: string;
  totalOrderCount?: number;
  url: string;
  userAgent: string;
  isLoggedIn: boolean;
}

export const buildRequestBody = ({
  branchId,
  customerId,
  ipAddress,
  marketingPreferencesAcknowledged,
  monetateId,
  path,
  preview,
  requestId,
  slotDate,
  slotType,
  totalOrderCount,
  url,
  userAgent,
  isLoggedIn,
}: BuildRequestBodyParams): MonetateApiRequestBody => {
  const pageType = getPageType(path);
  const isCustomerAuthenticated = customerId !== undefined && customerId !== '-1';

  return {
    channel: env.monetateApiChannel,
    ...(isCustomerAuthenticated ? { customerId } : {}),
    events: [
      {
        eventType: 'monetate:decision:DecisionRequest' as const,
        requestId,
        includeReporting: true,
      },
      {
        eventType: 'monetate:context:UserAgent' as const,
        userAgent,
      },
      ...(ipAddress
        ? [
            {
              eventType: 'monetate:context:IpAddress' as const,
              ipAddress,
            },
          ]
        : []),
      {
        eventType: 'monetate:context:PageView' as const,
        url,
        pageType,
      },
      {
        eventType: 'monetate:context:CustomVariables' as const,
        customVariables: [
          {
            variable: 'customerId',
            value: customerId || '-1',
          },
          {
            variable: 'branchId',
            value: String(branchId),
          },
          {
            variable: 'marketingPreferencesAcknowledged',
            value: String(marketingPreferencesAcknowledged),
          },
          {
            variable: 'slotDate',
            value: String(slotDate),
          },
          {
            variable: 'slotType',
            value: String(slotType),
          },
          {
            variable: 'totalOrderCount',
            value: String(totalOrderCount),
          },
          { variable: 'isLoggedIn', value: String(isLoggedIn || false) },
        ],
      },
    ],
    preview,
    monetateId,
  };
};
